module.exports = __webpack_public_path__ + "img/Fam4.9daab92e.jpg";